export default __webpack_public_path__ + "static/media/wool_white.8d300c38.jpg";